export default __webpack_public_path__ + "static/media/water.43f7b54c.png";